import React, { useContext, useEffect, useState } from 'react';
import {
  CurrentStepIndexContext,
  SetCurrentStepIndexContext,
  StepperDataDispatchContext
} from '../../../Contexts/StepperContext';
import { makeStyles, Typography } from '@material-ui/core';
import Title from '../../../Components/Labels/Title';
import { readNfcCard } from '../../../Utils/Nfc/nfcOperations';
import clsx from 'clsx';
import BaseButton from '../../../Components/Buttons/BaseButton';

const ReadCardStep = props => {
  const {
    setCurrentStep: setVisualStepperIndex,
    setNextButtonText,
    setGoBack
  } = props;
  const classes = useStyles();

  const setCurrentStep = useContext(SetCurrentStepIndexContext);
  const currentStepIndex = useContext(CurrentStepIndexContext);
  const setData = useContext(StepperDataDispatchContext);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setNextButtonText('Continuar');
    setVisualStepperIndex(currentStepIndex);
    setGoBack({ action: false });
    readNfcCard();
  }, [setNextButtonText, setVisualStepperIndex, currentStepIndex, setGoBack]);

  // Listen for NFC result from Android webview
  useEffect(() => {
    const handleNfcResult = event => {
      setLoading(false);

      if (!event || !event.detail) {
        setError('Respuesta inválida del lector NFC');
        return;
      }

      if (!event.detail.meterSerial) {
        setError(event.detail.errorMessage || 'Error al leer la tarjeta');
        return;
      }

      setData(d => ({ ...d, prepaidMeterCard: event.detail }));
      setCurrentStep(step => step + 1);
    };

    // expose a global function used by Android evaluateJavascript -> window.onNfcReadResult(result)
    window.onNfcReadResult = result => {
      window.dispatchEvent(
        new CustomEvent('nfcReadResult', { detail: result })
      );
    };

    window.addEventListener('nfcReadResult', handleNfcResult);

    return () => {
      window.removeEventListener('nfcReadResult', handleNfcResult);
      if (window.onNfcReadResult) {
        try {
          delete window.onNfcReadResult;
        } catch (e) {
          window.onNfcReadResult = undefined;
        }
      }
    };
  }, [setCurrentStep, setData]);

  return (
    <>
      <div className={classes.root}>
        <div
          className={clsx(classes.innerContentContainer, classes.centerContent)}
        >
          <Title title="Lee tu tarjeta" className={classes.title} />
          {loading && (
            <Typography className={classes.infoText} paragraph>
              Esperando respuesta del lector NFC...
            </Typography>
          )}
          {error && (
            <>
              <Typography className={classes.infoText} color="error" paragraph>
                {error}
              </Typography>
              <BaseButton
                color="primary"
                variant="outlined"
                fullWidth
                onClick={readNfcCard}
              >
                Reintentar
              </BaseButton>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    '&:last-child': {
      marginBottom: theme.spacing(2)
    }
  },
  innerContentContainer: {
    maxWidth: 950,
    justifyItems: 'center',
    alignContent: 'center',
    // viewport - header - footer - padding - stepper
    height: 'calc(100vh - 64px - 84px - 32px - 80px - 40px)'
  },
  centerContent: {
    margin: '0 auto'
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1.2,
    marginBottom: theme.spacing(4)
  },
  infoText: {
    fontSize: 14,
    textAlign: 'justify',
    marginBottom: theme.spacing(6)
  }
}));

export default ReadCardStep;
